import React from 'react';

import { Stack, Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';

type CustomerOrder = {
  shipName?: string;
  vendorName?: string;
} & App.Order;

const cruiseOfferDetailsFormatter = ({ row }: GridRenderCellParams<CustomerOrder>) => {
  return (
    <Stack direction="column" overflow="auto">
      <Typography variant="body2" fontWeight="bold" component="span">
        {row.vendorName}
      </Typography>
      <Typography variant="body2" color="text.secondary" component="span">
        {row.shipName}
      </Typography>
    </Stack>
  );
};

export default cruiseOfferDetailsFormatter;
